import { render, staticRenderFns } from "./statoOrdini.html?vue&type=template&id=54884f7a&scoped=true&"
import script from "./StatoOrdini.vue?vue&type=script&lang=js&"
export * from "./StatoOrdini.vue?vue&type=script&lang=js&"
import style0 from "./StatoOrdini.vue?vue&type=style&index=0&id=54884f7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54884f7a",
  null
  
)

export default component.exports